import React from 'react';
import { Grid } from '@mui/material';
import StoreSectionContainer from '../../Components/Store/StoreSectionContainer.js';
import SubscriptionItemLarge from './Components/SubscriptionItemLarge.js';
import SubscriptionItemLargeSkeleton from './Components/SubscriptionItemLargeSkeleton.js';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import { subscriptionQueries } from '../../graphql/queries';

const FeaturedSubscriptions = () => {
  const { t } = useTranslation();
  const { data, loading } = useQuery(subscriptionQueries.Subscriptions);
  const navigate = useNavigate();

  const subscriptions = ((data && data.subscriptions) || []).slice(0, 2);

  // While the 2 featured subscriptions load, hold the section's shape with skeleton
  // cards instead of rendering nothing and popping the whole block in.
  const items = loading
    ? Array.from({ length: 2 }, (_, index) => (
      <Grid item xs={12} sm={6} key={index}>
        <SubscriptionItemLargeSkeleton />
      </Grid>
    ))
    : subscriptions.map(subscription => (
      <Grid item xs={12} sm={6} key={subscription.id}>
        <SubscriptionItemLarge key={subscription.id} product={subscription} />
      </Grid>
    ));

  return (
    <StoreSectionContainer
      heading={t('our-subscriptions')}
      subheading={t('whether-youve-been-playing-or-getting-started')}
      ctaButtonLabel='view-all'
      onCtaButtonClick={() => { navigate('/products/all?Purchase+type=Subscription'); }}
      extraWhitespace
    >
      <Grid container spacing={3}>
        {items}
      </Grid>
    </StoreSectionContainer>
  );
};

export default FeaturedSubscriptions;
